import { render, staticRenderFns } from "./idnxt.vue?vue&type=template&id=59770260&"
import script from "./idnxt.vue?vue&type=script&lang=js&"
export * from "./idnxt.vue?vue&type=script&lang=js&"
import style0 from "./idnxt.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports